import React from "react";
import KidImg from "../../images/Specialoffer/KidImg.png";
import NavbarLogo from "../../images/Specialoffer/Market.png";

import "./Specialoffer.scss";
const Specialoffer = () => {
  return (
    <>
      <div className="Specialoffer">
        <div className="container">
          <div className="specialoffer_content">
            <div className="row">
              <div className="col-lg-6 col-md-12  imgkid">
                <img src={KidImg} alt="KidImg"></img>
              </div>
              <div className="col-lg-6 col-md-12 ">
                <div className="exploreheading">
                  <img src={NavbarLogo} alt="navimg"></img>
                  <h1>
                    Special offer <br></br>in kids products
                  </h1>
                  <p>
                    Tablets is a form of self-expression and autonomy at a
                    <br></br>
                    particular period and place.
                  </p>
                  <a href="DFFD">Discover more</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Specialoffer;
